<template>
  <div id="modalDetail">
    <div
      id="modal-doinwallet-detail"
      class="modal fade show"
      tabindex="-1"
      role="dialog"
      style="display: block; background-color: rgba(0, 0, 0, 0.5)"
      @click="close"
    >
      <div class="modal-dialog modal-doinwallet modal-dialog-centered modal-lg">
        <div class="modal-content" ref="modalContent" @click.stop>
          <div class="modal-header rounded-0">
            <span class="modal-title text-center mx-auto">
              Kalan Toplam Coin: {{ totalPoints }}<br>
              Kalan Toplam Coin Değeri TL: {{ totalTlValue.toFixed(2) }}
            </span>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <DoinWalletTable
              :columns="columns"
              :rows="doinWallets"
              @close="isDoinWallet = $event"
              :doinWallets="doinWallets"
            />
          </div>
          <div class="modal-footer border-0 justify-content-center">
            <div v-if="isWalletSeasonActive">
              <a :href="walletUrl" class="btn bg-orange text-white"
                >Fikir Coin'leri Bozdur</a
              >
            </div>
            <div v-else class="text-center">
              Fikir Coin bozdurma işlemleri duyurulacak olan dönem aralığında yapılabilmektedir.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DoinWalletTable from "./DoinWalletTable.vue";
import "vue-good-table/dist/vue-good-table.css";
export default {
  name: "DoinWallet",
  data() {
    return {
      isExitmodal: false,
      totalTlValue: 0,
    };
  },
  components: {
    DoinWalletTable,
  },
  filters: {},
  props: {
    totalPoints: {
      type: Number,
    },
    doinWallets: {
      type: Array,
    },
    columns: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    isWalletSeasonActive: {
      type: Boolean,
    },
    walletUrl: {
      type: String,
    },
    tlValue: {
      type: Number
    }
  },
  created() {
    const $body = document.querySelector("body");
    $body.style.overflow = "hidden";
    this.totalTlValue = this.totalPoints * this.tlValue;
  },
  methods: {
    close() {
      this.$emit("close", false);
      const $body = document.querySelector("body");
      $body.style.removeProperty("overflow");
    },
  },
};
</script>